// extracted by mini-css-extract-plugin
module.exports = {"SProgramContainer":"KinoprogramLoader_SProgramContainer__oVDMO","SFilterInfo":"KinoprogramLoader_SFilterInfo__MlQV4"};